import { tempoApi } from '@/lib/api/tempoApi';
import type {
  VirtualResource,
  VirtualResourceUpsertRequest,
} from '@/lib/api/types/capacity/resources';

const getVirtualResources = async ({ planId }: { planId: number }): Promise<VirtualResource[]> => {
  const response = await tempoApi()
    .get(`api/v1/adaptive-planner/plans/${planId}/virtual-resources`)
    .json<VirtualResource[]>();
  return response;
};

const bulkUpsertVirtualResources = async ({
  planId,
  data,
}: {
  planId: number;
  data: VirtualResourceUpsertRequest[];
}) => {
  const response = await tempoApi()
    .post(`api/v1/adaptive-planner/plans/${planId}/virtual-resources/upsert`, { json: data })
    .json<VirtualResource[]>();

  return response;
};

const bulkDeleteVirtualResources = async ({
  planId,
  ids,
}: {
  planId: number;
  ids: Set<number>;
}) => {
  const idsParam = Array.from(ids).join(',');
  return tempoApi().delete(
    `api/v1/adaptive-planner/plans/${planId}/virtual-resources/bulk?ids=${idsParam}`,
  );
};

export const AdaptivePlannerVirtualResourcesApi = {
  getVirtualResources,
  bulkUpsertVirtualResources,
  bulkDeleteVirtualResources,
} as const;
